import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import { USAAdmissionDayPage } from "@modules/study/webinar/usa_admission_day";

const UkAdmissionDay = () => {
  return (
    <LayoutMain
      title={`USA Admission Day`}
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/usa-study-event`}
    >
      <USAAdmissionDayPage />
    </LayoutMain>
  );
};

export default UkAdmissionDay;
